document.querySelectorAll('.category-selector').forEach(function (section) {
  var list = section.querySelector('[data-category-list]');
  if (!list) return;

  var items = Array.prototype.slice.call(
    list.querySelectorAll('[data-category-item]')
  );

  var media = section.querySelector('[data-category-media]');
  var imageWraps = media
    ? Array.prototype.slice.call(
        media.querySelectorAll('[data-category-image]')
      )
    : [];

  function activateItem(item) {
    if (item.classList.contains('is-active')) {
      return;
    }

    items.forEach(function (otherItem) {
      var otherPanel = otherItem.querySelector('[data-category-panel]');
      var otherTrigger = otherItem.querySelector('[data-category-trigger]');
      var isTarget = otherItem === item;

      otherItem.classList.toggle('is-active', isTarget);

      if (otherTrigger) {
        otherTrigger.setAttribute('aria-expanded', String(isTarget));
      }

      if (otherPanel) {
        otherPanel.inert = !isTarget;
      }
    });

    var targetIndex = item.getAttribute('data-category-index');

    imageWraps.forEach(function (wrap) {
      wrap.classList.toggle(
        'is-active',
        wrap.getAttribute('data-category-image') === targetIndex
      );
    });
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('[data-category-trigger]');
    var panel = item.querySelector('[data-category-panel]');

    if (!trigger) return;

    if (panel) {
      panel.inert = !item.classList.contains('is-active');
    }

    // Click
    trigger.addEventListener('click', function (event) {
      if (item.classList.contains('is-active')) {
        return;
      }

      event.preventDefault();
      activateItem(item);
    });

    // Hover
    trigger.addEventListener('mouseenter', function () {
      activateItem(item);
    });
  });
});